import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env['_NGX_ENV_FIREBASE_API_KEY'],
  authDomain: import.meta.env['_NGX_ENV_FIREBASE_AUTH_DOMAIN'],
  projectId: import.meta.env['_NGX_ENV_FIREBASE_PROJECT_ID'],
  storageBucket: import.meta.env['_NGX_ENV_FIREBASE_STORAGE_BUCKET'],
  messagingSenderId: import.meta.env['_NGX_ENV_FIREBASE_MESSAGING_SENDER_ID'],
  appId: import.meta.env['_NGX_ENV_FIREBASE_APP_ID'],
  measurementId: import.meta.env['_NGX_ENV_FIREBASE_MEASUREMENT_ID'],
};

const firebaseAuthConfig = {
  apiKey: import.meta.env['_NGX_ENV_FIREBASE_AUTH_API_KEY'],
  authDomain: import.meta.env['_NGX_ENV_FIREBASE_AUTH_AUTH_DOMAIN'],
  projectId: import.meta.env['_NGX_ENV_FIREBASE_AUTH_PROJECT_ID'],
  storageBucket: import.meta.env['_NGX_ENV_FIREBASE_AUTH_STORAGE_BUCKET'],
  messagingSenderId: import.meta.env['_NGX_ENV_FIREBASE_AUTH_MESSAGING_SENDER_ID'],
  appId: import.meta.env['_NGX_ENV_FIREBASE_AUTH_APP_ID'],
  measurementId: import.meta.env['_NGX_ENV_FIREBASE_AUTH_MEASUREMENT_ID'],
};

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  // NOTE: Because Firebase allows only one app per project, we need to initialize multiple apps for multiple projects.
  // If an app requires auth, we check if there is a specific auth config for it. If not, we use the primary app config.
  // If an app doesn't require auth, we use the primary app config.
  authApp = initializeApp(firebaseAuthConfig, 'auth');
  auth = getAuth(this.authApp);
  authDb = getFirestore(this.authApp);
  authFunctions = getFunctions(this.authApp, 'us-west4');
  authStorage = getStorage(this.authApp);

  app = initializeApp(firebaseConfig, 'app');
  db = getFirestore(this.app);
  functions = getFunctions(this.app, 'us-west4');
  storage = getStorage(this.app);
}
